import React from "react";
import CPCard from "../Assets/img/profile/Rectangle 1045.png";
// import CPCard from "../Assets/img/profile/image 21.png";
import Vector2 from "../Assets/img/profile/Vector (2).png";
import blogCard from "../Assets/img/Blogs/blogs.png";
import exploreCourses from "../Assets/img/profile/image 36.png";
import Vector from "../Assets/img/profile/Vector.png";
import clock from "../Assets/img/profile/Group 116.png";
import cloud from "../Assets/img/profile/akar-icons_cloud-upload.png";
import styles from "../Assets/css/overview.module.css";
import Sidebar from "../components/Sidebar";
import Notifications from "../components/Notifications";
import OverviewCenter from "../components/OverviewCenter";
import { useHistory } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Overview() {
	const history = useHistory();

	if (localStorage.token === "" || localStorage.token === undefined) {
		history.push("/signin");
	}
	return (
		<div>
			<Navbar />
			<div className={styles.body}>
				<div className={`container-fluid ${styles.dashboard}`}>
					<div className="row">
						<Sidebar />
						<OverviewCenter />
						<Notifications height="55vw" />
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default Overview;
